/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd, getColor } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';

const styles = StyleSheet.create((pd) => ({
  button: {
    backgroundColor: getColor(pd.sys.colour.container_max),
    borderTopLeftRadius: pd.ref.space.spacing10.px,
    borderTopRightRadius: pd.ref.space.spacing10.px,
    // Native transform (responsive translateX resolved per breakpoint).
    transform: [
      { rotate: '-90deg' },
      {
        translateX: {
          xs: '-25%',
          md: '-50%',
        },
      },
    ],
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: pd.ref.space.spacing20.px,
    paddingVertical: pd.ref.space.spacing10.px,
    transformOrigin: 'right',
    position: 'fixed' as any,
    right: 14,
    top: '50%' as any,
    zIndex: 100,
    overflow: 'visible',
    // On web, mixing a static `rotate` with a responsive `translateX` in one
    // transform array makes Unistyles emit them as SEPARATE `transform`
    // declarations (rotate in the base rule, translateX in the `md` media
    // query). CSS `transform` is not additive, so the media-query translateX
    // replaces the base rotate and the tab stops rotating. Provide the full
    // transform per breakpoint as one string so each rule keeps both.
    _web: {
      transform: {
        xs: 'rotate(-90deg) translateX(-25%)',
        md: 'rotate(-90deg) translateX(-50%)',
      },
    },
  },
  buttonPressed: {
    opacity: 0.8,
  },
  labelContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  label: {},
}));

export default styles;
